import { render } from "./FriendsList.vue?vue&type=template&id=2019dc34&scoped=true"
import script from "./FriendsList.vue?vue&type=script&lang=js"
export * from "./FriendsList.vue?vue&type=script&lang=js"

import "./FriendsList.vue?vue&type=style&index=0&id=2019dc34&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2019dc34"]])

export default __exports__